// extracted by mini-css-extract-plugin
module.exports = {"contactCard":"contact-module--contactCard--281ZT"};